import date from 'date-and-time';
import { IntlShape } from 'react-intl';

/**
 * A slot as a queue reads it: "Today 18:00", "Tomorrow 12:00", "Fri 19:00".
 *
 * The wire carries UTC. Nobody reads a queue in UTC, so the day and the hour
 * are both local.
 */
export function relativeSlotLabel(intl: IntlShape, iso: string, now: Date = new Date()): string {
  const at = new Date(iso);
  const time = intl.formatTime(at, { hour: '2-digit', minute: '2-digit', hour12: false });

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const day = new Date(at.getFullYear(), at.getMonth(), at.getDate());
  const distance = Math.round(date.subtract(day, today).toDays());

  if (distance === 0) {
    return `${intl.formatMessage({ id: 'app.sml.promote.slot.today', defaultMessage: 'Today' })} ${time}`;
  }
  if (distance === 1) {
    return `${intl.formatMessage({ id: 'app.sml.promote.slot.tomorrow', defaultMessage: 'Tomorrow' })} ${time}`;
  }
  return `${intl.formatDate(at, { weekday: 'short' })} ${time}`;
}
